
import React, { useEffect } from 'react'
import GoogleMapSearch from '../../../../../common/components/google-map-search';
import { InputContainer } from '../../../../../common/components/form/form.module';

export default function CargoBasicInfoComponent({ filterCustomer, handleCustomerSearch, customerListData, dropLocations, pickupLocations, setDropLocations, setPickupLocations, userInfo, handleChange, cargoValues }: any) {

    //Disabling of past time selection
    useEffect(() => {
        const input = document.getElementById("datetime") as HTMLInputElement;
        input.addEventListener("change", function () {
            const minDateTime = new Date(input.min);
            const selectedDateTime = new Date(input.value);
            if (selectedDateTime < minDateTime) {
                alert("Please select a valid time.");
                input.value = input.min; // reset to min
            }
        });

    }, []);

    return (

        <div className="w-full max-w-5xl mx-auto p-6 bg-white shadow-lg rounded-lg border border-gray-200 space-y-6">
            <div className="flex flex-col ">

                <InputContainer
                    label="ExistingUser"
                    name="IsExistingUser"
                    onValueChange={(event: any) => {
                        handleChange(
                            event,
                            'IsExistingUser'
                        )
                    }}
                    type="checkbox"
                    value={cargoValues?.IsExistingUser}
                />
                {
                    cargoValues?.IsExistingUser &&
                    <div className='pb-3'>
                        <InputContainer
                            label="Customer Name"
                            labelField="AccountName"
                            placeholder="Type to find a customer..."
                            isLoading={customerListData?.isLoading}
                            list={customerListData?.result?.items}
                            onTypeahead={(event: any) => handleCustomerSearch({ event })}
                            onValueChange={(event: any) => {
                                handleChange(
                                    event,
                                    'CustomerId'
                                )
                            }}
                            type="typeahead"
                            value={cargoValues?.CustomerId}
                            valueField="Id"
                        />
                    </div>

                }

                {/* Address Fields */}
                <div className="space-y-3 pb-3">
                    <div>
                        <label className="font-semibold line-clamp-2 mb-2 text-slate-800">From *</label>

                        <GoogleMapSearch
                            className="appearance-none Block w-full font-normal  text-black rounded shadow focus:outline-none focus:ring ps-8  pe-10 py-2"
                            setLocation={setPickupLocations}
                            location={pickupLocations}
                            placeholder="From Address" />


                    </div>
                </div>
                {!cargoValues?.IsExistingUser &&
                    <div className="space-y-3">
                        <div>
                            <label className="block font-semibold line-clamp-2 mb-2 text-slate-800">Email *</label>
                            <input
                                required
                                type="email"
                                name={"Email"}
                                className="block w-full bg-white border border-gray-300 rounded-md py-2 px-3 leading-tight focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                onChange={(event) => {
                                    handleChange(
                                        event.target.value,
                                        'Email'
                                    );

                                }}
                                value={cargoValues?.Email} />
                        </div>
                        <div>
                            <label className="block font-semibold line-clamp-2 mb-2 text-slate-800">Name *</label>
                            <input
                                required
                                type="text"
                                name={"Name"}
                                className="block w-full bg-white border border-gray-300 rounded-md py-2 px-3 leading-tight focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                onChange={(event) => {
                                    handleChange(
                                        event.target.value,
                                        'Name'
                                    );
                                }}
                                value={cargoValues?.Name} />
                        </div>
                        <div>
                            <label className="block font-semibold line-clamp-2 mb-2 text-slate-800">Phone Number *</label>
                            <input
                                required
                                type="text"
                                name="phone"
                                pattern="\d{10}"
                                maxLength={10}
                                className="block w-full bg-white border border-gray-300 rounded-md py-2 px-3 leading-tight focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                onChange={(event) => {
                                    handleChange(
                                        event.target.value.replace(/\D/g, ''),
                                        'PhoneNumber'
                                    );
                                }}
                                value={cargoValues?.PhoneNumber} />
                        </div>
                    </div>}

            </div>

            {cargoValues?.CustomerId && cargoValues?.IsExistingUser &&
                <div className="space-y-3">
                    <div>
                        <label className="block font-semibold line-clamp-2 mb-2 text-slate-800">Email</label>
                        <div className="w-full bg-gray-100 cursor-not-allowed border border-gray-300 rounded-md py-2 px-3 leading-tight focus:outline-none focus:ring-blue-500 focus:border-blue-500">{filterCustomer?.Email}</div>
                    </div>
                    <div>
                        <label className="block font-semibold line-clamp-2 mb-2 text-slate-800">Name</label>
                        <div className="w-full bg-gray-100 cursor-not-allowed border border-gray-300 rounded-md py-2 px-3 leading-tight focus:outline-none focus:ring-blue-500 focus:border-blue-500">{filterCustomer?.AccountName}</div>
                    </div>
                    <div>
                        <label className="block font-semibold line-clamp-2 mb-2 text-slate-800">Phone number</label>
                        <div className="w-full bg-gray-100 cursor-not-allowed border border-gray-300 rounded-md py-2 px-3 leading-tight focus:outline-none focus:ring-blue-500 focus:border-blue-500">{filterCustomer?.PhoneNumber}</div>
                    </div>
                </div>}


            <div className="space-y-3">
                <div>
                    <label className="font-semibold line-clamp-2 mb-2 text-slate-800">To *</label>
                    <GoogleMapSearch
                        className="appearance-none Block w-full font-normal  text-black rounded shadow focus:outline-none focus:ring ps-8  pe-10 py-2"
                        setLocation={setDropLocations}
                        location={dropLocations}
                        placeholder="To Address" />

                </div>
                <div>
                    <label className="block font-semibold line-clamp-2 mb-2 text-slate-800">Name *</label>
                    <input
                        required
                        type="text"
                        name="name"
                        className="block w-full bg-white border border-gray-300 rounded-md py-2 px-3 leading-tight focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        onChange={(event: any) => {
                            handleChange(
                                event.target.value,
                                'name'
                            )
                        }}
                        value={cargoValues?.name}
                    />


                </div>
                <div>
                    <label className="block font-semibold line-clamp-2 mb-2 text-slate-800">Phone Number *</label>

                    <input
                        required
                        type="text"
                        name="phone"
                        pattern="\d{10}"
                        maxLength={10}
                        className="block w-full bg-white border border-gray-300 rounded-md py-2 px-3 leading-tight focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        onChange={(event: any) => {
                            handleChange(
                                event.target.value.replace(/\D/g, ''),
                                'toPhoneNumber'
                            )
                        }}
                        value={cargoValues?.toPhoneNumber}
                    />

                </div>
                <div>
                    <label className="font-semibold line-clamp-2 mb-2 text-slate-800">Schedule Date *</label>
                    <input
                        required
                        id="datetime"
                        type="datetime-local"
                        name="scheduleDate"
                        min={
                            new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
                                .toISOString()
                                .slice(0, 16)
                        }
                        className="appearance-none block bg-white border border-gray-300 rounded-md py-2 px-3 leading-tight focus:outline-none focus:ring-blue-500 focus:border-blue-500 w-full"
                        onChange={(event) => handleChange(event.target.value, "date")}
                        onBlur={(event: any) => {
                            if (!event.target.value) alert(`Schedule Date is required`);
                        }}
                        onClick={(event) => {
                            const input = event.target as HTMLInputElement; // Type cast to HTMLInputElement
                            input.showPicker(); // Now you can call showPicker() safely
                        }}
                        value={cargoValues?.date}
                    />

                </div>
            </div>



            <div className="space-y-3">
                <div >
                    <label className="font-semibold line-clamp-2 mb-2 text-slate-800">Additional Information</label>
                    <div className=" border-x border-y border-black border-opacity-50 text-xs rounded" >
                        <textarea
                            name={"additionainfo"}
                            placeholder=""
                            className="w-full h-14 w-full bg-white border border-gray-300 rounded-md py-2 px-3 leading-tight focus:outline-none focus:ring-blue-500 focus:border-blue-5000"
                            onChange={(event: any) => {
                                handleChange(
                                    event.target.value,
                                    'Description'
                                )
                            }}
                            value={cargoValues?.Description}
                        />
                    </div>
                </div>
            </div>


        </div>


    )
}